/* assets/vs-pdp-bundle-2.js: second half of assets/vs-pdp-bundle.js (split only to keep each file
   a manageable size). Same rules; see the header of vs-pdp-bundle.js. Loaded right after it, with defer. */
(function () {
  var R = window.__VSBR = window.__VSBR || {};

  /* ===================== === vs-welcome-discount === ===================== */
  R["vs-welcome-discount"] = function (__c) {
(function () {
  var CODE = __c["CODE"];
  var LABEL = __c["LABEL"];
  var PARAM = __c["PARAM"];
  var NOTE = __c["NOTE"];
  var PSTR = __c["PSTR"];
  var AMOUNT = __c["AMOUNT"];   /* cents, fallback only */
  var PAY = __c["PAY"];
  var PLINE = __c["PLINE"];
  var KEY    = 'vs_welcome_discount';

  var banner = null, priceEl = null, priceNote = null;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  /* ---------- flag ---------- */
  function flagged() {
    var hit = false;
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.get(PARAM)) {
        hit = true;
        try { sessionStorage.setItem(KEY, CODE); } catch (e) {}
        qs.delete(PARAM);
        var rest = qs.toString();
        var clean = window.location.pathname + (rest ? '?' + rest : '') + window.location.hash;
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, clean);
        }
      }
    } catch (e) {}
    if (!hit) { try { hit = sessionStorage.getItem(KEY) === CODE; } catch (e) {} }
    return hit;
  }
  function clearFlag() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

  /* ---------- money, USD only ---------- */
  function toCents(txt) {
    if (!txt) return null;
    var t = String(txt).trim();
    if (t.charAt(0) !== '$') return null;              /* not USD, do no math */
    var m = t.match(/^\$\s*([\d,]+(?:\.\d{1,2})?)$/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/,/g, ''));
    if (isNaN(n)) return null;
    return Math.round(n * 100);
  }
  function fromCents(c) {
    return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, function (s, o) { return s; });
  }

  /* ---------- page anatomy ---------- */
  function addButton() {
    return document.querySelector('form[action*="/cart/add"] [name="add"]')
        || document.querySelector('[name="add"]')
        || document.querySelector('button.product-form__submit');
  }

  /* Find the price the way vs-pay-terms does: an element whose ENTIRE
     trimmed text is the price string, then climb to the outermost wrapper
     still containing only that price. Falls back to the nearest standalone
     currency string above the Add to Cart button. */
  function findPrice() {
    var btn = addButton();
    var all = document.querySelectorAll('span, div, p, strong, b, s, del, ins, bdi');
    var cands = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length) continue;
      var t = (el.textContent || '').trim();
      if (!t) continue;
      if (PSTR && t === PSTR) { cands.unshift(el); continue; }
      if (toCents(t) !== null) cands.push(el);
    }
    if (!cands.length) return null;
    var pick = cands[0];
    /* never grab a struck-through compare-at price */
    for (var j = 0; j < cands.length; j++) {
      var c = cands[j];
      if (c.closest('s, del, .compare-at, [class*="compare"]')) continue;
      pick = c; break;
    }
    if (btn && !pick) return null;
    var out = pick, par = pick.parentElement;
    while (par && par !== document.body &&
           (par.textContent || '').trim() === (pick.textContent || '').trim()) {
      out = par; par = out.parentElement;
    }
    return out;
  }

  function quantity() {
    var q = document.querySelector('form[action*="/cart/add"] [name="quantity"]')
         || document.querySelector('[name="quantity"]');
    if (!q) return 1;
    var n = parseInt(q.value, 10);
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function unitCents() {
    if (!priceEl) priceEl = findPrice();
    if (!priceEl) return null;
    return toCents((priceEl.textContent || '').trim());
  }

  /* ---------- rendering ---------- */
  function build() {
    var d = document.createElement('div');
    d.className = 'vs-wd';
    d.setAttribute('role', 'status');
    d.setAttribute('aria-live', 'polite');
    d.setAttribute('data-vs-wd', '1');
    d.innerHTML =
      '<svg class="vs-wd__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
        '<circle cx="10" cy="10" r="9" fill="#4E9B2E"></circle>' +
        '<path d="M6 10.4l2.6 2.6L14.2 7.4" stroke="#FFFFFF" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" fill="none"></path>' +
      '</svg>' +
      '<span><span class="vs-wd__amt"></span>' +
        '<span class="vs-wd__sub" hidden></span>' +
        (NOTE ? '<span class="vs-wd__note"></span>' : '') +
      '</span>';
    if (NOTE) d.querySelector('.vs-wd__note').textContent = NOTE;
    return d;
  }

  function tightRow(el) {
    var ref = el, par = el.parentElement;
    while (par && par !== document.body && par.childElementCount === 1) {
      ref = par; par = ref.parentElement;
    }
    return ref;
  }

  /* THE TRAP: the buy box is a flex column with explicit `order` values on
     phones. An injected element with no order defaults to 0 and jumps to the
     TOP of the column. Copy the sibling's order so DOM position decides. */
  function matchOrder(el, ref) {
    try {
      var par = ref.parentElement;
      if (!par) return;
      var pd = window.getComputedStyle(par).display;
      if (pd.indexOf('flex') === -1 && pd.indexOf('grid') === -1) return;
      var o = window.getComputedStyle(ref).order;
      if (o && o !== '0' && o !== 'auto') el.style.order = o;
    } catch (e) {}
  }

  function insert() {
    var found = document.querySelector('[data-vs-wd]');
    if (found) { banner = found; return banner; }
    var btn = addButton();
    if (!btn) return null;                      /* fail closed */
    var ref = tightRow(btn);
    var par = ref.parentElement;
    if (!par) return null;
    banner = build();
    par.insertBefore(banner, ref);
    matchOrder(banner, ref);
    return banner;
  }

  function insertPriceNote() {
    if (!PLINE) return;
    if (document.querySelector('[data-vs-wd-price]')) {
      priceNote = document.querySelector('[data-vs-wd-price]');
      return;
    }
    if (!priceEl) priceEl = findPrice();
    if (!priceEl || !priceEl.parentElement) return;
    priceNote = document.createElement('span');
    priceNote.className = 'vs-wd-price';
    priceNote.setAttribute('data-vs-wd-price', '1');
    priceEl.parentElement.insertBefore(priceNote, priceEl.nextSibling);
    matchOrder(priceNote, priceEl);
  }

  /* WRITE ONLY ON CHANGE. paint() runs from a MutationObserver, so an
     unconditional textContent write is a mutation that retriggers the
     observer and spins forever. Never make these writes unconditional. */
  function setText(el, s) {
    if (el && el.textContent !== s) el.textContent = s;
  }
  function setHidden(el, h) {
    if (el && el.hidden !== h) el.hidden = h;
  }

  /* the one place both lines are written, so they can never disagree */
  var painting = false;
  function paint() {
    if (painting || !banner) return;
    painting = true;
    try {
      setText(banner.querySelector('.vs-wd__amt'), LABEL + ' applied.');

      var unit = unitCents();
      var qty = quantity();
      var show = unit !== null && AMOUNT > 0 && qty === 1 && unit > AMOUNT;

      var sub = banner.querySelector('.vs-wd__sub');
      if (PAY && show) {
        setText(sub, "You'll pay " + fromCents(unit - AMOUNT) + ' at checkout.');
        setHidden(sub, false);
      } else {
        setText(sub, '');                     /* per-order discount, qty > 1 */
        setHidden(sub, true);
      }

      if (priceNote) {
        if (show) {
          setText(priceNote, fromCents(unit - AMOUNT) + ' with your ' + LABEL);
          setHidden(priceNote, false);
        } else {
          setText(priceNote, '');
          setHidden(priceNote, true);
        }
      }
    } finally {
      painting = false;
    }
  }

  /* ---------- confirm against the real cart ---------- */
  function confirmWithCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !banner) return;
        var codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        var match = null;
        for (var i = 0; i < codes.length; i++) {
          if (String(codes[i].code || '').toUpperCase() === CODE.toUpperCase()) {
            match = codes[i]; break;
          }
        }
        if (match) {
          var a = Number(match.amount || 0);
          if (a > 0 && (!cart.currency || cart.currency === 'USD')) {
            AMOUNT = a;                        /* Shopify's number wins */
            LABEL = fromCents(a).replace(/\.00$/, '') + ' off';
          }
          paint();
          return;
        }
        if (Number(cart.item_count) > 0) {     /* claim is false, remove it */
          banner.remove(); banner = null;
          if (priceNote) { priceNote.remove(); priceNote = null; }
          clearFlag();
        }
      })
      .catch(function () {});
  }

  ready(function () {
    if (!flagged()) return;
    if (!insert()) return;
    insertPriceNote();
    paint();
    confirmWithCart();

    /* variant switches rewrite the price, other snippets rebuild the buy
       box, and the quantity stepper changes the maths */
    document.addEventListener('change', paint, true);
    document.addEventListener('input', paint, true);

    var tries = 0;
    var mo = new MutationObserver(function () {
      if (!document.querySelector('[data-vs-wd]')) {
        if (++tries > 5) { mo.disconnect(); return; }
        if (insert()) { insertPriceNote(); confirmWithCart(); }
      }
      priceEl = null;                          /* price node may be replaced */
      paint();
    });
    try { mo.observe(document.body, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    setTimeout(function () { mo.disconnect(); }, 12000);
  });
})();
  };

  /* ===================== === vs-buybox-tidy === ===================== */
  R["vs-buybox-tidy"] = function (__c) {
(function(){
  if (window.__vsBuyboxTidy) { return; }
  window.__vsBuyboxTidy = true;

  var HOW_RE = /^(why you snore|how snoring actually works)\b/i;
  var MIN_RE = /^\d+\s*min read$/i;
  var TAIL_RE = /^[\s→›>·|–—-]*$/;
  var EX_RE = /free\s+size\s+exchanges?\s+included/i;
  var CS_RE = /^choose\s+your\s+size\b/i;
  var SG_RE = /^size\s+guide$/i;

  var BLOCKERS = '.vs-size-options, .vs-size-btn, [name="add"], form[action*="/cart/add"]';
  var FOURTEEN = '[data-vs-bb="14nights"], .vs-14-trigger, [class*="vs-14"]';

  function txt(el){
    if (!el) { return ''; }
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function inModal(el){
    if (!el || !el.closest) { return false; }
    return !!el.closest('[aria-modal="true"], dialog');
  }

  function pdp(){
    return document.querySelector('.vs-pdp') || document.body;
  }

  function blocked(el){
    if (!el || !el.querySelector) { return true; }
    return !!(el.querySelector(BLOCKERS) || el.querySelector(FOURTEEN));
  }

  /* deepest elements under root whose whole text matches re */
  function deepest(root, re, tags){
    var out = [];
    if (!root) { return out; }
    var els = root.querySelectorAll(tags);
    for (var i = 0; i < els.length; i++){
      var el = els[i];
      if (inModal(el)) { continue; }
      if (!re.test(txt(el))) { continue; }
      var childHit = false;
      for (var j = 0; j < el.children.length; j++){
        if (re.test(txt(el.children[j]))) { childHit = true; break; }
      }
      if (!childHit) { out.push(el); }
    }
    return out;
  }

  /* ---------- 2. "Free size exchanges included." ---------- */

  function hideExchange(){
    var hits = deepest(pdp(), EX_RE, 'p, span, div, li, small, em, strong, b, label');
    for (var i = 0; i < hits.length; i++){
      var el = hits[i];
      if (el.closest('a, button')) { continue; }
      var target = el;
      for (var k = 0; k < 2; k++){
        var p = target.parentElement;
        if (!p || p === document.body) { break; }
        if (blocked(p)) { break; }
        if (txt(p) !== txt(target)) { break; }
        target = p;
      }
      target.classList.add('vs-bt-hide');
    }
  }

  /* ---------- 4. "Why you snore" + read time ---------- */

  function howCandidates(){
    var list = [];
    var tagged = document.querySelectorAll('[data-vs-bb="how"]');
    for (var t = 0; t < tagged.length; t++){ list.push(tagged[t]); }
    var links = pdp().querySelectorAll('a, button');
    for (var i = 0; i < links.length; i++){
      var l = links[i];
      if (inModal(l)) { continue; }
      if (HOW_RE.test(txt(l)) && list.indexOf(l) === -1) { list.push(l); }
    }
    return list;
  }

  function hideHow(){
    var list = howCandidates();
    for (var n = 0; n < list.length; n++){
      var el = list[n];
      if (!el || !el.parentElement) { continue; }
      if (el.querySelector && el.querySelector(FOURTEEN)){
        var inner = null;
        var kids = el.querySelectorAll('a, button');
        for (var q = 0; q < kids.length; q++){
          if (HOW_RE.test(txt(kids[q]))) { inner = kids[q]; break; }
        }
        if (!inner) { continue; }
        el = inner;
      }
      var target = el;
      /* climb only while the parent holds essentially nothing else */
      for (var k = 0; k < 2; k++){
        var p = target.parentElement;
        if (!p || p === document.body) { break; }
        if (blocked(p)) { break; }
        var rest = txt(p).replace(txt(target), '').trim();
        if (rest !== '' && !MIN_RE.test(rest) && !TAIL_RE.test(rest)) { break; }
        target = p;
      }
      target.classList.add('vs-bt-hide');
      var sib = target.nextElementSibling;
      if (sib && MIN_RE.test(txt(sib))) { sib.classList.add('vs-bt-hide'); }
      var prev = target.previousElementSibling;
      if (prev && MIN_RE.test(txt(prev))) { prev.classList.add('vs-bt-hide'); }
    }
  }

  /* If a later pass of vs-buybox-order drops the First 14 Nights
     trigger INTO something we hid, give that wrapper back and hide
     only the link inside it. */
  function rescue(){
    var hidden = document.querySelectorAll('.vs-bt-hide');
    for (var i = 0; i < hidden.length; i++){
      var el = hidden[i];
      if (el.querySelector && el.querySelector(FOURTEEN)){
        el.classList.remove('vs-bt-hide');
      }
    }
  }

  /* ---------- 3. Size Guide onto the heading row ---------- */

  function sizeScope(){
    return document.querySelector('.vs-pdp .vs-size-section')
        || document.querySelector('.vs-size-section')
        || pdp();
  }

  function findHeading(){
    var hits = deepest(sizeScope(), CS_RE, 'h1, h2, h3, h4, h5, h6, p, span, div, label, legend, strong');
    for (var i = 0; i < hits.length; i++){
      var el = hits[i];
      if (el.closest('a, button')) { continue; }
      if (blocked(el)) { continue; }
      return el;
    }
    return null;
  }

  function findSizeGuide(){
    var sg = document.querySelector('.vs-sgfix') || document.querySelector('.vs-sglink');
    if (sg) { return sg; }
    var cands = deepest(pdp(), SG_RE, 'a, button, span, div, p');
    for (var i = 0; i < cands.length; i++){
      var c = cands[i];
      if (inModal(c)) { continue; }
      if (/^H[1-6]$/.test(c.tagName)) { continue; }
      return c.closest('a, button') || c;
    }
    return null;
  }

  function moveSizeGuide(){
    if (document.querySelector('.vs-bt-head > .vs-bt-sg')) { return true; }
    var head = findHeading();
    if (!head) { return false; }
    var sg = findSizeGuide();
    if (!sg) { return false; }
    if (sg === head || sg.contains(head)) { return false; }

    var oldParent = sg.parentElement;
    head.classList.add('vs-bt-head');
    sg.classList.add('vs-bt-sg');
    head.appendChild(sg);

    if (oldParent && oldParent !== head && oldParent !== document.body && !oldParent.contains(head)){
      if (txt(oldParent) === ''
          && !oldParent.querySelector('img, svg, input, select, button, a')
          && !blocked(oldParent)){
        oldParent.classList.add('vs-bt-hide');
      }
    }
    return true;
  }

  /* ---------- boot ---------- */

  var busy = false;

  function apply(){
    if (busy) { return; }
    busy = true;
    try {
      rescue();
      hideExchange();
      hideHow();
      moveSizeGuide();
    } catch (e) {}
    busy = false;
  }

  function boot(){
    apply();
    var times = [300, 800, 1600, 3000, 5000, 8000];
    for (var i = 0; i < times.length; i++){ setTimeout(apply, times[i]); }

    if (!window.MutationObserver) { return; }
    var timer = null;
    var passes = 0;
    var obs = new MutationObserver(function(){
      if (passes > 40) { obs.disconnect(); return; } /* 15-Sep-2026: stop watching once the cap is hit */
      if (timer) { return; }
      timer = setTimeout(function(){
        timer = null;
        passes++;
        apply();
      }, 250);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  /* ===================== === vs-atc-size-label === ===================== */
  R["vs-atc-size-label"] = function (__c) {
(function(){
  if (window.__vsAtcSizeLabel) { return; }
  window.__vsAtcSizeLabel = true;

  var VARIANTS = __c["VARIANTS"];

  var FULL_RE = /Add\s+.*?\s+to\s+Cart/i;
  var BARE_RE = /Add\s+to\s+Cart/i;
  var SIZE_RE = /^\s*(men|women)['’]?s?\s*size/i;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, OPTION: 1 };

  /* the sticky bar keeps a plain "Add to Cart" label */
  var NO_LABEL = '#vsb-atc, .vsb-add, [data-vs-no-size-label]';
  var STICKY_BTN = '#vsb-add';

  function txt(el){
    if (!el) { return ''; }
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function inModal(el){
    if (!el || !el.closest) { return false; }
    return !!el.closest('[aria-modal="true"], dialog');
  }

  function norm(s){
    return String(s || '').replace(/[’ʼ]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /* ---------- which size is selected ---------- */

  function fromInput(){
    var inputs = document.querySelectorAll('input[name="id"], select[name="id"]');
    for (var i = 0; i < inputs.length; i++){
      var el = inputs[i];
      if (inModal(el)) { continue; }
      var val = (el.value || '').trim();
      if (val && VARIANTS[val]) { return VARIANTS[val]; }
    }
    return null;
  }

  function isSelected(btn){
    if (btn.getAttribute('aria-pressed') === 'true') { return true; }
    if (btn.getAttribute('aria-checked') === 'true') { return true; }
    if (btn.getAttribute('aria-selected') === 'true') { return true; }
    if (/\b(is-)?(selected|active|checked)\b/.test(btn.className || '')) { return true; }
    var radio = btn.querySelector('input[type="radio"]');
    if (radio && radio.checked) { return true; }
    if (/\bselected\b/i.test(txt(btn))) { return true; }
    return false;
  }

  function fromCards(){
    var btns = document.querySelectorAll('.vs-size-btn, .vs-size-options button, .vs-size-options label');
    for (var i = 0; i < btns.length; i++){
      var b = btns[i];
      if (inModal(b) || !isSelected(b)) { continue; }
      var t = txt(b);
      for (var k in VARIANTS){
        if (norm(t).indexOf(norm(VARIANTS[k])) === 0) { return VARIANTS[k]; }
      }
      var m = t.match(SIZE_RE);
      if (m){
        var word = m[1].toLowerCase() === 'women' ? 'Women' : 'Men';
        return word + '’s Size';
      }
    }
    return null;
  }

  function currentSize(){
    return fromInput() || fromCards();
  }

  /* ---------- the buttons ---------- */

  function targets(){
    var out = [];
    var all = document.querySelectorAll('button, a, [role="button"], input[type="submit"]');
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (inModal(el)) { continue; }
      if (el.closest(NO_LABEL)) { continue; }
      var t = txt(el);
      if (!t) { continue; }
      if (t.length > 90) { continue; }
      if (FULL_RE.test(t) || BARE_RE.test(t)) { out.push(el); }
    }
    return out;
  }

  function labelNode(el){
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    var bare = null;
    while ((node = walker.nextNode())){
      var p = node.parentNode;
      if (!p || SKIP[p.nodeName]) { continue; }
      if (FULL_RE.test(node.nodeValue)) { return { node: node, re: FULL_RE }; }
      if (!bare && BARE_RE.test(node.nodeValue)) { bare = { node: node, re: BARE_RE }; }
    }
    return bare;
  }

  function paint(){
    var size = currentSize();
    if (!size) { return; }
    var label = 'Add ' + size + ' to Cart';
    var list = targets();
    for (var i = 0; i < list.length; i++){
      var el = list[i];
      if (el.tagName === 'INPUT'){
        if (el.value !== label) { el.value = label; }
        continue;
      }
      var hit = labelNode(el);
      if (hit){
        var next = hit.node.nodeValue.replace(hit.re, label);
        if (next !== hit.node.nodeValue) { hit.node.nodeValue = next; }
      }
      /* a button with its own aria-label is read from that, not from
         the text, so it has to move with it or the two disagree */
      var al = el.getAttribute('aria-label');
      if (al && (FULL_RE.test(al) || BARE_RE.test(al))){
        var alNext = al.replace(FULL_RE.test(al) ? FULL_RE : BARE_RE, label);
        if (alNext !== al) { el.setAttribute('aria-label', alNext); }
      }
    }
  }

  /* ---------- sticky bar: open the slide cart, do not add again ---------- */

  var refire = false;

  function openSlideCart(){
    try {
      if (typeof window.SLIDECART_UPDATE === 'function') { window.SLIDECART_UPDATE(); }
    } catch (e) {}
    try {
      if (typeof window.SLIDECART_OPEN === 'function') { window.SLIDECART_OPEN(); return true; }
    } catch (e) {}
    var trigger = document.querySelector('[data-slidecart-open], .slidecart-open, .js-slidecart-open');
    if (trigger){ trigger.click(); return true; }
    window.location.href = '/cart';
    return false;
  }

  function passThrough(btn){
    refire = true;
    try { btn.click(); } catch (e) {}
    setTimeout(function(){ refire = false; }, 0);
  }

  function onStickyClick(ev){
    if (refire) { return; }
    var btn = ev.target && ev.target.closest ? ev.target.closest(STICKY_BTN) : null;
    if (!btn || btn.disabled) { return; }

    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) { ev.stopImmediatePropagation(); }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (cart && cart.item_count > 0){
          openSlideCart();
        } else {
          passThrough(btn);
        }
      })
      .catch(function(){ passThrough(btn); });
  }

  /* ---------- boot ---------- */

  var busy = false;

  function tick(){
    if (busy) { return; }
    busy = true;
    try { paint(); } catch (e) {}
    busy = false;
  }

  function boot(){
    tick();
    var times = [200, 600, 1200, 2500, 4000, 6000];
    for (var i = 0; i < times.length; i++){ setTimeout(tick, times[i]); }

    document.addEventListener('click', onStickyClick, true);
    document.addEventListener('click', function(){ setTimeout(tick, 60); setTimeout(tick, 260); }, true);
    document.addEventListener('change', function(){ setTimeout(tick, 30); }, true);
    /* 15-Sep-2026 speed: was a forever 600ms timer. Clicks and size changes
       already re-run tick() above, so the timer now stops after ~10s. */
    var ticks = 0;
    var iv = setInterval(function(){ tick(); if (++ticks >= 17) { clearInterval(iv); } }, 600);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  /* ===================== === vs-pdp-copy === ===================== */
  R["vs-pdp-copy"] = function (__c) {
(function () {
  if (window.__vsPdpCopy) return;
  window.__vsPdpCopy = true;

  var DO_SUBHEAD = __c["DO_SUBHEAD"];
  var DO_BULLETS = __c["DO_BULLETS"];
  var DO_ATC_NOTE = __c["DO_ATC_NOTE"];
  var DO_PRICE_NOTE = __c["DO_PRICE_NOTE"];
  var DO_RETURNS = __c["DO_RETURNS"];
  var DO_EMOTION = __c["DO_EMOTION"];
  var DO_DEDUPE = __c["DO_DEDUPE"];

  /* 'emotional' (default) or 'mechanism'. Pass subhead_mode: 'mechanism'
     from the hub to run the feature-led line instead. */
  var SUBHEAD_MODE = __c["SUBHEAD_MODE"];

  var RETURNS_URL = 'https://www.vitalsleepreturns.com';

  /* ---------- copy ---------- */

  var SUBHEAD_FROM = 'Sleep quieter. Wake up rested.';

  /* Emotional (default). The shopper is not buying quiet, they are
     buying back the room. Names the feeling, claims nothing. */
  var SUBHEAD_EMO  = 'You stopped hearing it a long time ago. They never did.';

  /* Feature-led alternative, kept for a head-to-head test. The
     mechanism is already carried by bullet 2, so this is optional. */
  var SUBHEAD_MECH = 'Adjusts in 1 mm steps, so you can find the setting that works for you.';

  /* [from, to] - matched on the text node's WHOLE trimmed text */
  var BULLETS = [
    ['Sleep more quietly and wake up feeling refreshed',
     'Easily molds to your teeth for a personalized fit'],
    ['Adjust the lower jaw position for improved airflow and quieter sleep',
     'Adjustable for improved breathing and quieter sleep'],
    ['Quieter nights for your partner, better rest for you',
     'Quieter nights for you, and your bed partner']
  ];

  var ATC_NOTE_FROM = /^60[-\s]night money[-\s]back guarantee\.?$/i;
  var ATC_NOTE_TO   = ' nights to find your setting.';
  var ATC_NOTE_NUM  = '60';

  var PRICE_NOTE = 'Or 4 payments of $42.49 with Shop Pay. No prescription, no appointments.';

  /* Emotional swaps outside the buy box. Same rule as the bullets:
     whole-text-node match, so a partial phrase can never be hit. */
  var EMOTION = [
    ['Finally enjoy a quiet night together.',
     'Nobody decides to sleep in separate rooms. It just happens, one night at a time.']
  ];

  /* Stacked-guarantee cuts. The page states the 60-night guarantee about
     18 times, which on its own is fine: direct response repeats risk
     reversal near every CTA on purpose. The problem is the places where
     two near-identical guarantee statements TOUCH, which reads as filler
     and makes the promise feel like boilerplate.

     Neither of these deletes the guarantee. Each one replaces a repeated
     statement with information the page does NOT already carry in that
     spot, so the block keeps its job and stops echoing.

     RUNS BEFORE the returns step, and matches the ORIGINAL page text.
     Once these have run, RETURN_RULES no longer match here, which is
     intended: this copy already points at the returns portal. */
  var DEDUPE_RULES = [
    /* 1. End of "Why VitalSleep Costs More". The guarantee band sits
          next to this block, so the refund sentence is a straight echo.
          The replacement programme is the part that is NOT repeated. */
    {
      test: /Try it for 60 nights\.\s*If it is not right for you, you get your money back\.\s*If it wears out in the first year, the replacement program covers it\./i,
      to:   '<strong>A full year of free replacements is included.</strong> ' +
            'If it wears out, contact us and we ship a new one at no cost.'
    },
    /* 2. The FAQ answered the guarantee twice. "What is the VitalSleep
          money-back guarantee?" already covers the policy in full, so
          this one becomes the troubleshooting answer the FAQ lacks.
          Doubles as return deflection: fit and adjustment drive most
          returns, and most of those are a setting away from working. */
    {
      test: /You're covered by a 60-night money-back guarantee\.\s*If you're not satisfied, you can request a refund according to the return policy\.\s*For customer support,?\s*email\s*support@vitalsleep\.com\.?/i,
      to:   'Work through the full adjustment range before you decide. ' +
            'Most people who think it is not working are a millimeter or two ' +
            'from the setting that does. Start at the lowest setting, advance ' +
            'the jaw 1 mm at a time, and give each setting a couple of nights. ' +
            'If you have been through the range and it still is not right, ' +
            'start your refund at ' + link() + '.'
    }
  ];

  /* Refund rewrites. tests run against the element's trimmed textContent. */
  var RETURN_RULES = [
    {
      test: /Not satisfied\?\s*Email\s*support@vitalsleep\.com\s*for a full refund\./i,
      to:   'Not satisfied? Start your refund at ' + link() + '.'
    },
    {
      test: /you can request a refund according to the return policy\.\s*For customer support,?\s*email\s*support@vitalsleep\.com\.?/i,
      to:   'request your refund at ' + link() + '. For anything else, email ' +
            '<a href="mailto:support@vitalsleep.com">support@vitalsleep.com</a>.'
    },
    {
      test: /we refund every penny\.\s*Need help\?\s*support@vitalsleep\.com/i,
      to:   'we refund every penny. Start your refund at ' + link() +
            '. Need help first? <a href="mailto:support@vitalsleep.com">support@vitalsleep.com</a>'
    }
  ];

  function link() {
    return '<a href="' + RETURNS_URL + '" rel="noopener">vitalsleepreturns.com</a>';
  }

  /* ---------- helpers ---------- */

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, TEMPLATE: 1 };

  function textNodes(root) {
    var out = [];
    if (!root) return out;
    var w;
    try {
      w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          while (p && p !== root) {
            if (p.nodeType === 1 && SKIP[p.tagName]) return NodeFilter.FILTER_REJECT;
            p = p.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
    } catch (e) { return out; }
    var n;
    while ((n = w.nextNode())) out.push(n);
    return out;
  }

  function norm(s) {
    return (s || '').replace(/’/g, "'").replace(/\s+/g, ' ').trim();
  }

  /* replace a text node whose WHOLE trimmed text equals `from` */
  function swapExact(from, to) {
    var want = norm(from).toLowerCase().replace(/[.\s]+$/, '');
    var hit = 0;
    textNodes(document.body).forEach(function (n) {
      var got = norm(n.nodeValue).toLowerCase().replace(/[.\s]+$/, '');
      if (got !== want) return;
      var keepDot = /[.!?]\s*$/.test(n.nodeValue);
      n.nodeValue = to + (keepDot && !/[.!?]$/.test(to) ? '.' : '');
      hit++;
    });
    return hit;
  }

  /* smallest element whose textContent matches, and which holds only
     inline children - so a whole section can never be rewritten */
  var INLINE_OK = { A: 1, B: 1, I: 1, EM: 1, STRONG: 1, SPAN: 1, BR: 1, SMALL: 1, U: 1 };

  function safeToRewrite(el) {
    if (!el || el.nodeType !== 1) return false;
    if (SKIP[el.tagName]) return false;
    var kids = el.children || [];
    if (kids.length > 6) return false;
    for (var i = 0; i < kids.length; i++) {
      if (!INLINE_OK[kids[i].tagName]) return false;
      if (kids[i].children && kids[i].children.length > 2) return false;
    }
    return true;
  }

  function rewriteElement(rule, marker) {
    marker = marker || 'data-vs-copy';
    var all, hit = 0;
    try { all = document.body.querySelectorAll('p, li, div, span, td, h1, h2, h3, h4, h5, h6'); }
    catch (e) { return 0; }
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var txt = norm(el.textContent);
      if (!rule.test.test(txt)) continue;
      /* prefer the SMALLEST match: skip if a descendant also matches */
      var deeper = false;
      var kids = el.querySelectorAll('p, li, div, span, td, h1, h2, h3, h4, h5, h6');
      for (var k = 0; k < kids.length; k++) {
        if (rule.test.test(norm(kids[k].textContent))) { deeper = true; break; }
      }
      if (deeper) continue;
      if (!safeToRewrite(el)) continue;
      if (el.getAttribute(marker) === 'done') continue;
      try {
        el.innerHTML = txt.replace(rule.test, rule.to);
        el.setAttribute(marker, 'done');
        hit++;
      } catch (e) {}
    }
    return hit;
  }

  /* ---------- steps ---------- */

  function doSubhead() {
    var to = (SUBHEAD_MODE === 'mechanism') ? SUBHEAD_MECH : SUBHEAD_EMO;
    return swapExact(SUBHEAD_FROM, to);
  }

  function doEmotion() {
    var n = 0;
    EMOTION.forEach(function (pair) { n += swapExact(pair[0], pair[1]); });
    return n;
  }

  function doBullets() {
    var n = 0;
    BULLETS.forEach(function (pair) { n += swapExact(pair[0], pair[1]); });
    return n;
  }

  function doAtcNote() {
    var hit = 0;
    textNodes(document.body).forEach(function (t) {
      if (!ATC_NOTE_FROM.test(norm(t.nodeValue))) return;
      t.nodeValue = ATC_NOTE_NUM + ATC_NOTE_TO;
      hit++;
    });
    return hit;
  }

  function atcButton() {
    var b = document.querySelector('[name="add"]');
    if (b) return b;
    var all = document.querySelectorAll('button, a');
    for (var i = 0; i < all.length; i++) {
      if (/add\s.*\bto cart\b|^add to cart$/i.test(norm(all[i].textContent))) return all[i];
    }
    return null;
  }

  /* price node = element whose ENTIRE text is a currency amount */
  function priceEl() {
    var btn = atcButton();
    if (!btn) return null;
    var scope = btn.closest ? btn.closest('form, .product, [class*="product"]') : null;
    scope = scope || document.body;
    var cands = scope.querySelectorAll('span, div, p, strong, s, ins, bdi');
    var best = null;
    for (var i = 0; i < cands.length; i++) {
      var t = norm(cands[i].textContent);
      if (!/^\$\s?[\d,]+(\.\d{2})?$/.test(t)) continue;
      if (cands[i].children && cands[i].children.length) continue;
      best = cands[i];
      break;
    }
    return best;
  }

  function doPriceNote() {
    if (document.querySelector('.vs-price-note')) return 0;
    var p = priceEl();
    if (!p) return 0;
    var host = p.parentNode;
    if (!host) return 0;
    var d = document.createElement('div');
    d.className = 'vs-price-note';
    d.textContent = PRICE_NOTE;
    d.style.cssText = 'font-size:13px;line-height:1.45;color:#5a6270;margin:4px 0 0;';
    try { host.insertBefore(d, p.nextSibling); } catch (e) { return 0; }
    return 1;
  }

  function doDedupe() {
    var n = 0;
    DEDUPE_RULES.forEach(function (r) { n += rewriteElement(r, 'data-vs-dedupe'); });
    return n;
  }

  function doReturns() {
    var n = 0;
    RETURN_RULES.forEach(function (r) { n += rewriteElement(r); });
    return n;
  }

  /* ---------- run ---------- */

  var STEPS = [
    [function () { return DO_SUBHEAD; },    doSubhead,   'subhead'],
    [function () { return DO_BULLETS; },    doBullets,   'bullets'],
    [function () { return DO_ATC_NOTE; },   doAtcNote,   'atcNote'],
    [function () { return DO_EMOTION; },    doEmotion,   'emotion'],
    [function () { return DO_DEDUPE; },     doDedupe,    'dedupe'],
    [function () { return DO_RETURNS; },    doReturns,   'returns'],
    [function () { return DO_PRICE_NOTE; }, doPriceNote, 'priceNote']
  ];

  var report = {};

  function pass() {
    STEPS.forEach(function (s) {
      if (!s[0]()) return;
      var n = 0;
      try { n = s[1]() || 0; } catch (e) { n = 0; }
      report[s[2]] = (report[s[2]] || 0) + n;
    });
    window.__vsPdpCopyReport = report;
  }

  function boot() {
    pass();
    /* late content: GemPages blocks, FAQ accordions, and the other
       vs-* snippets all insert after DOMContentLoaded. Re-run on a
       short leash rather than observing forever. */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      pass();
      if (tries >= 8) clearInterval(iv);
    }, 700);

    var mo;
    try {
      mo = new MutationObserver(function () { pass(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 8000);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  /* ===================== === vs-pdp-title === ===================== */
  R["vs-pdp-title"] = function (__c) {
(function(){
  if (window.__vsPdpTitle) { return; }
  window.__vsPdpTitle = true;

  var TITLE = __c["TITLE"];
  var OUTSIDE = 'header, footer, nav, [aria-modal="true"], dialog, [role="dialog"]';
  var BIG = 'screen and (min-width: 990px)';
  var BIGGER = 'screen and (min-width: 1280px)';

  function norm(s){
    return String(s || '')
      .replace(/[’ʼ]/g, "'")
      .replace(/[\s ]+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function txt(el){
    return (el && el.textContent ? el.textContent : '').replace(/[\s ]+/g, ' ').trim();
  }

  function usable(el){
    if (!el || !el.closest || !el.getBoundingClientRect) { return false; }
    if (el.closest(OUTSIDE)) { return false; }
    if (el.closest('a, button, select, option')) { return false; }
    var r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) { return false; }
    return true;
  }

  /* DEEPEST element whose whole text is the product title. Every
     element is searched, not just headings, because the title on this
     theme is not guaranteed to be an h1 and the 95KB product section
     cannot be read to check. */
  function findTitle(){
    var want = norm(TITLE);
    if (!want) { return null; }
    var all = document.body.querySelectorAll('*');
    var best = null;
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (norm(txt(el)) !== want) { continue; }
      if (!usable(el)) { continue; }
      if (best && best.contains(el)) { best = el; }
      else if (!best) { best = el; }
    }
    return best;
  }

  /* Inline, with priority, on the element AND every descendant set to
     inherit -- a stylesheet rule on the parent is silently ignored
     when a child span carries its own font-size. */
  function paint(el, px){
    el.style.setProperty('font-size', px + 'px', 'important');
    el.style.setProperty('line-height', '1.22', 'important');
    var kids = el.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++){
      kids[i].style.setProperty('font-size', 'inherit', 'important');
      kids[i].style.setProperty('line-height', 'inherit', 'important');
    }
  }

  function unpaint(el){
    el.style.removeProperty('font-size');
    el.style.removeProperty('line-height');
    var kids = el.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++){
      kids[i].style.removeProperty('font-size');
      kids[i].style.removeProperty('line-height');
    }
  }

  function wide(q){
    return window.matchMedia ? window.matchMedia(q).matches : false;
  }

  var target = null;

  function apply(){
    if (!target || !target.isConnected) {
      target = findTitle();
      if (target) { target.classList.add('vs-pdp-h1'); }
    }
    if (!target) { return false; }
    /* DESKTOP ONLY. Below 990px the inline size is removed outright,
       so a phone or a narrowed window is left exactly as it was. */
    if (wide(BIGGER)) { paint(target, 34); }
    else if (wide(BIG)) { paint(target, 30); }
    else { unpaint(target); }
    return true;
  }

  function boot(){
    apply();
    var times = [200, 600, 1500, 3000, 6000];
    for (var i = 0; i < times.length; i++){ setTimeout(apply, times[i]); }
    window.addEventListener('resize', function(){
      clearTimeout(window.__vsPdpTitleT);
      window.__vsPdpTitleT = setTimeout(apply, 150);
    }, { passive: true });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  /* ===================== === vs-order-focus === ===================== */
  R["vs-order-focus"] = function (__c) {
(function(){
  if (window.__vsOrderFocus) { return; }
  window.__vsOrderFocus = true;

  var DO_COLLAPSE = __c["DO_COLLAPSE"];
  var DO_TIMELINE = __c["DO_TIMELINE"];
  var DO_VALUE = __c["DO_VALUE"];
  var DO_BULLET = __c["DO_BULLET"];
  var BULLET = __c["BULLET"];

  var OLD_RE = /^60\s+nights\s+to\s+find\s+it\b/i;

  function txt(el){
    if (!el) { return ''; }
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function pdp(){
    return document.querySelector('.vs-pdp') || document.body;
  }

  /* ---------- A. collapse ---------- */

  function blocks(){
    var list = [];
    if (DO_TIMELINE){
      list.push({ sel:'.vs-pdp .vs-timeline', head:'.vs-timeline-title' });
    }
    if (DO_VALUE){
      list.push({ sel:'.vs-pdp .vs-value-list', head:'.vs-value-list-title' });
    }
    return list;
  }

  function bind(block, head){
    function toggle(){
      var closed = block.classList.contains('vsf-closed');
      block.classList.toggle('vsf-closed', !closed);
      block.classList.toggle('vsf-open', closed);
      head.setAttribute('aria-expanded', closed ? 'true' : 'false');
    }
    head.addEventListener('click', function(e){
      e.preventDefault();
      toggle();
    });
    head.addEventListener('keydown', function(e){
      var k = e.key;
      if (k === 'Enter' || k === ' ' || k === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32){
        e.preventDefault();
        toggle();
      }
    });
  }

  function collapseAll(){
    var list = blocks();
    for (var i = 0; i < list.length; i++){
      var b = list[i];
      var block = document.querySelector(b.sel);
      if (!block) { continue; }
      if (block.getAttribute('data-vsf') === '1') { continue; }

      var head = block.querySelector(b.head);
      if (!head) { continue; }

      /* the title must be a DIRECT child, or the :not() rule that
         hides the body would hide the title's wrapper too */
      while (head.parentElement && head.parentElement !== block){
        head = head.parentElement;
      }
      if (head.parentElement !== block) { continue; }

      head.classList.add('vsf-head');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', 'false');

      block.classList.add('vsf-block', 'vsf-closed');
      block.setAttribute('data-vsf', '1');
      bind(block, head);
    }
  }

  /* ---------- B. bullet ---------- */

  function writeText(el, val){
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node, first = null;
    while ((node = walker.nextNode())){
      if ((node.nodeValue || '').trim() === '') { continue; }
      if (!first){ first = node; } else { node.nodeValue = ''; }
    }
    if (!first) { return false; }
    first.nodeValue = val;
    return true;
  }

  function swapBullet(){
    var els = pdp().querySelectorAll('li, p, span, div');
    for (var i = 0; i < els.length; i++){
      var el = els[i];
      if (!OLD_RE.test(txt(el))) { continue; }
      var childHit = false;
      for (var j = 0; j < el.children.length; j++){
        if (OLD_RE.test(txt(el.children[j]))) { childHit = true; break; }
      }
      if (childHit) { continue; }
      writeText(el, BULLET);
      return;
    }
  }

  /* ---------- boot ---------- */

  var busy = false;

  function apply(){
    if (busy) { return; }
    busy = true;
    try {
      if (DO_COLLAPSE) { collapseAll(); }
      if (DO_BULLET)   { swapBullet(); }
    } catch (e) {}
    busy = false;
  }

  function boot(){
    apply();
    var times = [300, 800, 1600, 3000, 5000, 8000];
    for (var i = 0; i < times.length; i++){ setTimeout(apply, times[i]); }

    if (!window.MutationObserver) { return; }
    var timer = null;
    var passes = 0;
    var obs = new MutationObserver(function(){
      if (passes > 40) { return; }
      if (timer) { return; }
      timer = setTimeout(function(){
        timer = null;
        passes++;
        apply();
      }, 250);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  /* ===================== === vs-cro-copy === ===================== */
  R["vs-cro-copy"] = function (__c) {
(function () {
  var ON = __c["ON"];

  var report = { runs: 0 };
  window.__vsCroCopy = report;

  function bump(k, n) {
    if (!n) { return; }
    report[k] = (report[k] || 0) + n;
  }

  /* ---- rule table: [flag, key, pattern, replacement] -------------- */
  var RULES = [
    /* BUTTON LABELS RUN FIRST. A term rule would otherwise rewrite the
       inside of a label ("GET SNORE-FREE SLEEP" -> "GET quieter sleep")
       before the label rule ever sees it. */
    ['ctas', 'cta', /ORDER NOW FOR RESTFUL SLEEP/g, 'CHOOSE YOUR SIZE'],
    ['ctas', 'cta', /ORDER TODAY FOR BETTER SLEEP/g, 'CHOOSE YOUR SIZE'],
    ['ctas', 'cta', /GET SNORE-FREE SLEEP/g, 'CHOOSE YOUR SIZE'],
    ['ctas', 'cta', /GET QUIET SLEEP/g, 'CHOOSE YOUR SIZE'],
    ['ctas', 'cta', /Give VitalSleep a Try/g, 'Choose Your Size'],
    ['ctas', 'cta', /Unlock Your Restful Sleep/g, 'Choose Your Size'],
    ['ctas', 'cta', /Get One That Fits Your Mouth/g, 'Choose Your Size'],
    ['ctas', 'cta', /Start Sleeping Quietly/g, 'Choose Your Size'],
    /* the phone number in the buy box guarantee panel is wrong */
    ['phone', 'phone', /1-866-3780/g, '1-866-753-3780'],

    /* one guarantee wording, everywhere: 60 nights */
    ['guarantee', 'guarantee', /60-Day Satisfaction Guarantee/g, '60-Night Satisfaction Guarantee'],
    ['guarantee', 'guarantee', /60-Day Guarantee/g, '60-Night Guarantee'],
    ['guarantee', 'guarantee', /60-day money-back guarantee/g, '60-night money-back guarantee'],
    ['guarantee', 'guarantee', /60-Day Money-Back Guarantee/g, '60-Night Money-Back Guarantee'],
    ['guarantee', 'guarantee', /Try It For 60 Days/g, 'Try It For 60 Nights'],
    ['guarantee', 'guarantee', /Try it for 60 days/g, 'Try it for 60 nights'],
    ['guarantee', 'guarantee', /60-Day Trial/g, '60-Night Trial'],
    ['guarantee', 'guarantee', /60-Day Risk Free Trial/g, '60 nights to decide'],
    /* one warranty wording */
    ['guarantee', 'warranty', /12-month replacement protection/g, 'free replacements for a year'],
    ['guarantee', 'warranty', /1-Year warranty/g, 'Free replacements for a year'],

    /* banned terms: no "stop snoring", no "custom" fit language */
    ['terms', 'terms', /Why VitalSleep Stops Snoring/g, 'How VitalSleep Reduces Snoring'],
    ['terms', 'terms', /No more snoring/g, 'Quieter nights'],
    ['terms', 'terms', /eliminating the vibration/g, 'reducing the vibration'],
    ['terms', 'terms', /helps stop your snoring/g, 'helps reduce your snoring'],
    ['terms', 'terms', /Custom molded thermoplastic fit/g, 'Molded thermoplastic fit'],
    ['terms', 'terms', /Custom molded fit/g, 'Molded fit'],
    ['terms', 'terms', /Custom molds to your teeth/g, 'Molds to your teeth'],
    ['terms', 'terms', /Custom Teeth Impressions/g, 'Molded Teeth Impressions'],
    ['terms', 'terms', /Custom-molded/g, 'Molded'],
    ['terms', 'terms', /Custom-fitted/g, 'Molded'],
    ['terms', 'terms', /CUSTOM-FIT COMFORT/g, 'MOLDED-FIT COMFORT'],
    ['terms', 'terms', /custom fit/g, 'molded fit'],
    ['terms', 'terms', /Custom Fit/g, 'Molded Fit'],
    ['terms', 'terms', /SNORE-FREE SLEEP/g, 'QUIETER SLEEP'],
    ['terms', 'terms', /Snore-Free Sleep/g, 'Quieter Sleep'],
    ['terms', 'terms', /snore-free sleep/g, 'quieter sleep'],
    ['terms', 'terms', /fully customizable boil-and-bite fit/g, 'moldable boil-and-bite fit'],
    ['terms', 'terms', /Customize your airway opening/g, 'Adjust your airway opening'],
    ['terms', 'terms', /customizable/g, 'adjustable'],
    ['terms', 'terms', /Risk Free Trial/g, 'Trial'],
    ['terms', 'terms', /risk-free/gi, 'no-hassle'],
    ['terms', 'terms', /FDA approved/gi, 'FDA-cleared'],
    ['terms', 'terms', /clinically proven/gi, 'designed'],
    ['terms', 'terms', /CPAP alternative/gi, 'option alongside CPAP'],
    ['terms', 'terms', /Eliminate disruptive snoring/g, 'Reduce disruptive snoring'],

    /* NO REMOLDING TEXT. Standing rule, 24-Aug-2026. */
    ['terms', 'terms', /Can I refit it\?/g, 'What if the fit is not right?'],
    ['terms', 'terms', /Easy to re-mold if adjustments are needed/g, 'Free replacement if the fit is not right'],

    /* one price anchor for a dentist-made device */
    ['price_anchor', 'anchor', /\$3,000\+ dental device quotes/g, '$800+ dental device quotes'],

    /* delivery window has to agree with the FAQ */
    ['shipping', 'shipping', /2–5 business days/g, '2–4 business days'],
    ['shipping', 'shipping', /2-5 business days/g, '2-4 business days'],

  ];

  /* EXPLICIT LIST, NOT A RANGE. The obvious version used the Unicode
     blocks, and ☀-➿ swallows the check marks (✔) and the
     stars (★) this buy box uses as real content. Only the emoji
     actually on this page are listed here. */
  var EMOJI = /(?:\u{1F614}|\u{1F60A}|\u{1F4E6}|\u{1F4B0}|\u{1F4DE}|\u{1F501}|\u{26A1}|\u{1F30D}|\u{1F62E}|\u{2699}|\u{1F389}|\u{1F525}|\u{1F44D}|\u{1F634}|\u{1F971}|\u{1F6E1})\u{FE0F}?/gu;

  function walk(fn) {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p) { return NodeFilter.FILTER_REJECT; }
        var t = p.nodeName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'TEXTAREA' || t === 'NOSCRIPT') {
          return NodeFilter.FILTER_REJECT;
        }
        if (p.closest && p.closest('[contenteditable="true"]')) {
          return NodeFilter.FILTER_REJECT;
        }
        if (!n.nodeValue || !n.nodeValue.trim()) { return NodeFilter.FILTER_REJECT; }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = w.nextNode())) { fn(n); }
  }

  function applyRules() {
    walk(function (node) {
      var v = node.nodeValue;
      var out = v;
      for (var i = 0; i < RULES.length; i++) {
        var r = RULES[i];
        if (!ON[r[0]]) { continue; }
        if (r[2].test(out)) {
          r[2].lastIndex = 0;
          out = out.replace(r[2], r[3]);
          bump(r[1], 1);
        }
        r[2].lastIndex = 0;
      }
      if (out !== v) { node.nodeValue = out; }
    });
  }

  function stripEmoji() {
    if (!ON.emoji) { return; }
    walk(function (node) {
      var v = node.nodeValue;
      if (!EMOJI.test(v)) { EMOJI.lastIndex = 0; return; }
      EMOJI.lastIndex = 0;
      var stripped = v.replace(EMOJI, '');
      if (!stripped.trim()) {
        /* the node is ONLY an emoji: an avatar bubble, a badge, a
           decorative glyph. Emptying the text leaves a blank circle,
           so hide the element that holds it instead. */
        hideLoneEmoji(node);
        return;
      }
      node.nodeValue = stripped.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
      bump('emoji', 1);
    });
  }

  /* Climb to the OUTERMOST ancestor that still contains nothing but
     this emoji, so the coloured bubble goes with it rather than
     leaving an empty circle. Stops the moment an ancestor holds any
     other content, and never hides anything interactive. */
  function hideLoneEmoji(node) {
    if (!ON.lone_emoji) { return; }
    var el = node.parentNode;
    if (!el || el.nodeType !== 1) { return; }
    var glyph = node.nodeValue.trim();
    var top = null;
    var hops = 0;
    while (el && el.nodeType === 1 && hops < 4) {
      if (el === document.body) { break; }
      if ((el.textContent || '').trim() !== glyph) { break; }
      if (el.querySelector('a, button, input, select, img, video')) { break; }
      top = el;
      el = el.parentNode;
      hops++;
    }
    if (!top) { return; }
    if (top.getAttribute('data-vs-emoji') === 'hidden') { return; }
    top.setAttribute('data-vs-emoji', 'hidden');
    top.style.display = 'none';
    bump('emoji_hidden', 1);
  }

  /* The size FAQ describes sizes that do not exist on this store
     ("Regular" and "Small") and tells unsure buyers to size DOWN,
     which is the opposite of what the exchange data supports. */
  var SIZE_NEW =
    'VitalSleep comes in two sizes. The Women’s size is about 10% smaller ' +
    'than the Men’s size. Most men order Men’s and most women order ' +
    'Women’s. Not sure? Take the 10 second fit quiz before you order. ' +
    'Size exchanges are free either way.';

  function fixSizeFaq() {
    if (!ON.faq_size) { return; }
    var els = document.querySelectorAll('p, div, li, span');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var txt = (el.textContent || '');
      if (txt.indexOf('standard (Regular)') === -1) { continue; }
      if (txt.length > 700) { continue; }
      /* only a plain copy block: no media, no controls, no links */
      if (el.querySelector('img, svg, input, select, button, a, video')) { continue; }
      if (el.querySelector('p, li')) { continue; }
      el.textContent = SIZE_NEW;
      bump('faq_size', 1);
      return;
    }
  }

  /* The comparison FAQ names two competitors and makes specific
     head-to-head product and warranty claims about them. That is the
     exact surface the Dental Choice / Airwaav letters were about, so
     it is replaced with the same facts stated about VitalSleep only. */
  var COMPARE_NEW =
    'VitalSleep is adjustable. You mold it to your own teeth, then move the ' +
    'lower tray forward in 1 mm steps across a 0 to 8 mm range until you find ' +
    'the setting that works for you. It is an FDA-cleared over-the-counter ' +
    'device, made in the USA, and it comes with free replacements for a year. ' +
    'Fixed-position mouthpieces give you one setting and no way to change it.';

  function fixCompareFaq() {
    if (!ON.terms) { return; }
    var els = document.querySelectorAll('p, div, li, span');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var txt = (el.textContent || '');
      if (txt.indexOf('ZQuiet') === -1) { continue; }
      if (txt.length > 900) { continue; }
      if (el.querySelector('img, svg, input, select, button, a, video')) { continue; }
      if (el.querySelector('p, li')) { continue; }
      el.textContent = COMPARE_NEW;
      bump('compare_faq', 1);
      return;
    }
  }

  /* The refit FAQ tells buyers to remold the device they already own.
     Standing rule 24-Aug-2026: no remolding text in VitalSleep copy.
     The promise is a free replacement or a free size exchange. */
  var REFIT_NEW =
    'If the fit is not right, do not force it. Contact us and we will send a ' +
    'free replacement so you can fit a new one. If the tray size is wrong, ' +
    'the size exchange is free as well.';

  function fixRefitFaq() {
    if (!ON.terms) { return; }
    var els = document.querySelectorAll('p, div, li, span');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var txt = (el.textContent || '');
      if (txt.indexOf('refit it') === -1) { continue; }
      if (txt.length > 600) { continue; }
      if (el.querySelector('img, svg, input, select, button, a, video')) { continue; }
      if (el.querySelector('p, li')) { continue; }
      el.textContent = REFIT_NEW;
      bump('refit_faq', 1);
      return;
    }
  }

  function pass() {
    report.runs++;
    try { applyRules(); } catch (e) {}
    try { stripEmoji(); } catch (e) {}
    try { fixSizeFaq(); } catch (e) {}
    try { fixCompareFaq(); } catch (e) {}
    try { fixRefitFaq(); } catch (e) {}
  }

  function boot() {
    pass();
    /* GemPages and the FAQ app paint late, so repeat a few times */
    [300, 900, 1800, 3000].forEach(function (ms) { setTimeout(pass, ms); });

    if (window.MutationObserver) {
      var queued = false;
      var mo = new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        setTimeout(function () { queued = false; pass(); }, 250);
      });
      mo.observe(document.body, { childList: true, subtree: true });
      /* stop watching after the page has settled */
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };

  /* ===================== === vs-more-ctas === ===================== */
  R["vs-more-ctas"] = function (__c) {
(function(){
  if (window.__vsMoreCtasBooted) { return; }
  window.__vsMoreCtasBooted = true;

  var PRICE = __c["PRICE"];
  var MIN_GAP = __c["MIN_GAP"];
  var PULSE = __c["PULSE"];
  var NOTE_ON = __c["NOTE_ON"];

  var ON = __c["ON"];

  /* This store's money_format wraps the amount in a span, so the
     filter returns markup, not a number. Liquid strips the tags; this
     is the second guard, and it also tidies the spacing the format
     leaves behind ("$ 169.95" -> "$169.95"). The note is inserted as a
     TEXT NODE, so any tag left in here would print on the page. */
  if (PRICE) {
    PRICE = String(PRICE).replace(/<[^>]*>/g, '')
                         .replace(/\s+/g, ' ')
                         .replace(/([$£€¥])\s+/g, '$1')
                         .trim();
  }

  var NOTE_60 = '60 nights to find your setting.';
  var NOTE_PRICE = PRICE ? ('One payment of ' + PRICE + '. ' + NOTE_60) : NOTE_60;

  var SLOTS = [
    { k:'am3',     type:'link', label:'Pick your size and end the 3 A.M. shifts',
      re:/it\s+starts\s+(out\s+)?at\s+3\s*a\.?\s*m/i },
    { k:'once',    type:'btn',  label:'Choose Your Size', note:NOTE_PRICE,
      re:/buy\s+it\s+once/i },
    { k:'compare', type:'btn',  label:'Get the One That Adjusts', note:NOTE_60,
      re:/fixed\s+mouthpieces\s+guess|vitalsleep\s+adjusts/i },
    { k:'findfit', type:'link', label:'See sizes and pricing',
      re:/find\s+your\s+fit[\.,]?\s+fine[\s-]?tune/i },
    { k:'works',   type:'link', label:'Choose your size',
      re:/the\s+snoring\s+mouthpiece\s+that\s+finally\s+works/i },
    { k:'steps',   type:'btn',  label:'Start My 60 Nights', note:NOTE_60,
      re:/fit\s+it[\.,]?\s+sleep\s+better/i },
    { k:'easy',    type:'link', label:'Ready? Choose your size',
      re:/easy\s+to\s+use\s*(&|and|&amp;)\s*comfortable/i },
    { k:'faq',     type:'btn',  label:'Choose Your Size', note:NOTE_PRICE,
      re:/frequently\s+asked\s+questions/i }
  ];

  /* Buy-intent CTAs already on the page. "Take the quiz" is NOT one:
     the quiz band sits right under the comparison table and must not
     suppress the CTA that belongs there. */
  var CTA_RE = /(add\s+to\s+cart)|(choose\s+your\s+size)|(get\s+one\s+that)|(get\s+the\s+one\s+that)|(start\s+my\s+60)|(buy\s+now)|(order\s+now)|(shop\s+now)|(get\s+yours)|(pick\s+your\s+size)|(see\s+sizes\s+and\s+pricing)|(sizes\s+and\s+pricing)/i;

  var BOOTED  = Date.now();
  var passes  = 0;
  var busy    = false;
  var timer   = null;

  function txt(el){ return (el.textContent || '').replace(/\s+/g,' ').trim(); }

  function visible(el){
    if (!el || !el.getBoundingClientRect) { return false; }
    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) { return false; }
    var cs = el.ownerDocument.defaultView.getComputedStyle(el);
    if (!cs) { return true; }
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  function excluded(el){
    if (!el) { return true; }
    if (el.closest('[aria-modal="true"], [role="dialog"], dialog, header, footer, nav')) { return true; }
    if (el.closest('.vs-mcta, .vs-sticky-atc, .sticky-atc, [class*="sticky"]')) { return true; }
    return false;
  }

  function sectionOf(el){
    return el.closest('[id^="shopify-section"]') || document.body;
  }

  /* The top-level child of the section that holds this heading. The
     CTA goes after it, so it lands at the end of that block. */
  function blockOf(el){
    var sec = sectionOf(el), n = el;
    while (n && n.parentElement && n.parentElement !== sec && n.parentElement !== document.body) {
      n = n.parentElement;
    }
    return (n && n.parentElement) ? n : null;
  }

  /* Deepest visible element whose own text matches, so a wrapper never
     shadows the heading inside it. Real headings first, then the
     elements GemPages uses when it does not emit heading tags. */
  function findHeading(re){
    var pools = ['h1,h2,h3,h4,h5,h6', 'p,div,span,strong,b,em'];
    for (var p = 0; p < pools.length; p++) {
      var all = document.querySelectorAll(pools[p]);
      var hits = [];
      for (var i = 0; i < all.length; i++) {
        var el = all[i], t = txt(el);
        if (!t || t.length > 110) { continue; }
        if (!re.test(t)) { continue; }
        if (excluded(el)) { continue; }
        if (!visible(el)) { continue; }
        hits.push(el);
      }
      var deep = hits.filter(function(el){
        return !hits.some(function(o){ return o !== el && el.contains(o); });
      });
      if (deep.length) { return deep[0]; }
    }
    return null;
  }

  function isBuyBox(el){
    if (!el) { return false; }
    if (el.querySelector('[name="add"], .vs-size-options, .vs-size-btn')) { return true; }
    return false;
  }

  /* A buy CTA already sitting at the end of this block, or immediately
     after it inside the same section. */
  function endsInCta(block){
    var scan = [block, block.nextElementSibling];
    for (var s = 0; s < scan.length; s++) {
      var n = scan[s];
      if (!n || n.nodeType !== 1) { continue; }
      if (n.classList && n.classList.contains('vs-mcta')) { return true; }
      var cands = n.querySelectorAll('a, button, [role="button"]');
      for (var i = 0; i < cands.length; i++) {
        if (CTA_RE.test(txt(cands[i])) && visible(cands[i])) { return true; }
      }
      if ((n.tagName === 'A' || n.tagName === 'BUTTON') && CTA_RE.test(txt(n))) { return true; }
    }
    return false;
  }

  function build(slot){
    var wrap = document.createElement('div');
    wrap.className = 'vs-mcta';
    wrap.setAttribute('data-vs-mcta', slot.k);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = (slot.type === 'btn') ? 'vs-mcta-btn' : 'vs-mcta-link';
    b.setAttribute('data-vs-mcta-go', slot.k);
    b.appendChild(document.createTextNode(slot.label));
    var arw = document.createElement('span');
    arw.className = 'vs-mcta-arw';
    arw.setAttribute('aria-hidden', 'true');
    arw.appendChild(document.createTextNode('→'));
    b.appendChild(arw);
    wrap.appendChild(b);

    if (slot.type === 'btn' && slot.note && NOTE_ON) {
      var p = document.createElement('p');
      p.className = 'vs-mcta-note';
      p.appendChild(document.createTextNode(slot.note));
      wrap.appendChild(p);
    }
    return wrap;
  }

  function place(slot){
    if (!ON[slot.k]) { return 'off'; }
    if (document.querySelector('[data-vs-mcta="' + slot.k + '"]')) { return 'ok'; }
    var h = findHeading(slot.re);
    if (!h) { return 'miss'; }
    var block = blockOf(h);
    if (!block || !block.parentNode) { return 'miss'; }
    if (isBuyBox(block) || isBuyBox(sectionOf(h))) { return 'skip'; }
    if (endsInCta(block)) { return 'skip'; }
    var r = block.getBoundingClientRect();
    var y = r.bottom + (window.pageYOffset || document.documentElement.scrollTop || 0) + 30;
    if (crowded(y, ctaTops())) { return 'crowded'; }
    block.parentNode.insertBefore(build(slot), block.nextSibling);
    return 'new';
  }

  function topOf(el){
    var r = el.getBoundingClientRect();
    return r.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  /* Every CTA already on the page, ours and the theme's, as scroll
     positions. Used to decide crowding BEFORE inserting, never after:
     a node that is inserted and then removed has already painted, and
     the shopper sees an orange bar flash and vanish. */
  function ctaTops(){
    var tops = [];
    var all = document.querySelectorAll('a, button, [role="button"], input[type="submit"], [data-vs-mcta]');
    for (var i = 0; i < all.length; i++) {
      var c = all[i];
      if (c.hasAttribute && c.hasAttribute('data-vs-mcta')) {
        if (visible(c)) { tops.push(topOf(c)); }
        continue;
      }
      if (c.closest('[data-vs-mcta]')) { continue; }
      if (excluded(c)) { continue; }
      var label = txt(c) || c.value || '';
      if (!CTA_RE.test(label)) { continue; }
      if (!visible(c)) { continue; }
      tops.push(topOf(c));
    }
    return tops;
  }

  function crowded(y, tops){
    for (var i = 0; i < tops.length; i++) {
      if (Math.abs(tops[i] - y) < MIN_GAP) { return true; }
    }
    return false;
  }

  function headerH(){
    var best = 0;
    var els = document.querySelectorAll('header, .header, [class*="header"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cs = window.getComputedStyle(el);
      if (!cs) { continue; }
      if (cs.position !== 'fixed' && cs.position !== 'sticky') { continue; }
      var r = el.getBoundingClientRect();
      if (r.top > 2 || r.height < 20) { continue; }
      if (r.height > best) { best = r.height; }
    }
    return Math.min(best, 170);
  }

  function buyTarget(){
    var pdp = document.querySelector('.vs-pdp') || document;
    return pdp.querySelector('.vs-size-options')
        || pdp.querySelector('.vs-size-btn')
        || document.querySelector('.vs-size-options')
        || document.querySelector('[name="add"]')
        || null;
  }

  function goBuy(key){
    var t = buyTarget();
    if (!t) { return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = topOf(t) - headerH() - 16;
    if (y < 0) { y = 0; }
    try {
      window.scrollTo({ top:y, behavior: reduce ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, y);
    }
    if (PULSE) {
      var host = t.classList && t.classList.contains('vs-size-options') ? t : (t.parentElement || t);
      host.classList.add('vs-mcta-pulse');
      setTimeout(function(){ host.classList.remove('vs-mcta-pulse'); }, 1700);
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event:'vitalsleep_mid_page_cta', vs_cta_slot:key });
    }
  }

  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('[data-vs-mcta-go]') : null;
    if (!t) { return; }
    e.preventDefault();
    goBuy(t.getAttribute('data-vs-mcta-go'));
  }, false);

  function apply(){
    if (busy) { schedule(120); return; }
    /* Nothing is placed until layout has settled. Measuring before
       images and lazy blocks land gives compressed positions, which
       reads as crowding that is not really there. Every CTA is below
       the fold, so waiting for load costs nothing on screen. */
    if (document.readyState !== 'complete' && (Date.now() - BOOTED) < 2000) {
      schedule(250);
      return;
    }
    busy = true;
    passes++;
    var report = { placed:[], missing:[], skipped:[], crowded:[] };
    try {
      for (var i = 0; i < SLOTS.length; i++) {
        var r = place(SLOTS[i]);
        if (r === 'new' || r === 'ok') { report.placed.push(SLOTS[i].k); }
        else if (r === 'miss') { report.missing.push(SLOTS[i].k); }
        else if (r === 'skip') { report.skipped.push(SLOTS[i].k); }
        else if (r === 'crowded') { report.crowded.push(SLOTS[i].k); }
      }
      report.passes = passes;
      window.__vsMoreCtas = report;
    } catch (err) {
      if (window.console && console.warn) { console.warn('vs-more-ctas', err); }
    }
    busy = false;
  }

  /* Never skip on busy, always reschedule: a dropped mutation would
     otherwise wait for the next fixed timer. */
  function schedule(ms){
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(function(){ timer = null; apply(); }, ms);
  }

  function boot(){
    apply();
    [700, 1600, 3200, 6000].forEach(function(ms){ setTimeout(apply, ms); });
    try {
      var mo = new MutationObserver(function(){
        if (passes > 60) { mo.disconnect(); return; }
        schedule(250);
      });
      mo.observe(document.body, { childList:true, subtree:true });
    } catch (e) {}
    window.addEventListener('resize', function(){ schedule(400); }, { passive:true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  };
})();
